import { render, staticRenderFns } from "./lead-from-automatic.vue?vue&type=template&id=30f0ab50&scoped=true&"
import script from "./lead-from-automatic.vue?vue&type=script&lang=js&"
export * from "./lead-from-automatic.vue?vue&type=script&lang=js&"
import style0 from "./lead-from-automatic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lead-from-automatic.vue?vue&type=style&index=1&id=30f0ab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f0ab50",
  null
  
)

export default component.exports